import React, { useEffect, useState } from 'react'
import '.././App.css';
import { auth, db } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { EmailAuthProvider, reauthenticateWithCredential, updatePassword } from 'firebase/auth';
import Swal from 'sweetalert2';

function Header() {

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });

    const [status, setstatus] = useState("Active")
    const [name, setName] = useState("")
    const [mobile, setMobile] = useState("")
    const [password, setPassword] = useState("")
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();

    const signOut = () => {
        auth.signOut();
        window.location.href = "/login";
    }


    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
            fetchData1()
        });
    });

    const fetchData1 = async () => {
        try {
            if (userData) {
                if (loadincount) {
                    const docRef = doc(db, "users", userData.uid)
                    const docSnap = await getDoc(docRef)
                    if (docSnap.exists()) {
                        if (docSnap.data().status === 'Deactive') {
                            Toast.fire({
                                icon: "error",
                                title: 'Account Not De Activated!!'
                            });

                            signOut()
                        }

                        setMobile(docSnap.data().mobile);
                        setPassword(docSnap.data().password);
                        setstatus(docSnap.data().status);
                        setName(docSnap.data().username);
                        setloadincount(false)
                    }
                }
            }
        } catch (error) {
            console.log(error);
        }
    }

    const handleUpdatePassword = async () => {
        // Check if password is long enough
        if (password.length < 6) {
            Toast.fire({
                icon: "error",
                title: 'Please fill all the fields!!'
            });
            return;
        }
    
        try {
            const user = auth.currentUser;
            if (user) {
                // Prompt for the user's current password to reauthenticate
                const currentPassword = prompt("Please enter your current password");
    
                if (!currentPassword) {
                    Toast.fire({
                        icon: "error",
                        title: 'Current password is required!'
                    });
                    return;
                }
    
                // Reauthenticate the user
                const credential = EmailAuthProvider.credential(user.email, currentPassword);
                await reauthenticateWithCredential(user, credential);
    
                // Once reauthenticated, update the password
                await updatePassword(user, password);
    
                // Update the password in Firestore users collection
                const userRef = doc(db, "users", userData.uid);
                await updateDoc(userRef, { password: password });
    
               
                Toast.fire({
                    icon: "success",
                    title: 'Password Updated!!'
                });

                signOut();

            }
        } catch (error) {
            console.log(error);
    
            // Show error message
            Toast.fire({
                icon: "error",
                title: 'Error updating password: ' + error.message
            });
        }
    };


    return (
        <div>

            <nav className="main-header navbar navbar-expand navbar-teal navbar-light" style={{backgroundColor:"#008280ff"}}>
                {/* Left navbar links */}
                <ul className="navbar-nav">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="pushmenu" href="#0" role="button"><i style={{ color: "white" }} className="fas fa-bars" /></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="#0" >
                            <b style={{ color: "white", textTransform: "uppercase" }}> DASARA EXECUTIVE </b>
                        </a>
                    </li>
                </ul>
                {/* Right navbar links */}
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item">
                        <a className="nav-link" data-widget="fullscreen" href="#0" role="button">
                            <i style={{ color: "white" }} className="fas fa-expand-arrows-alt" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" data-widget="control-sidebar" data-slide="true" href="#0" role="button" data-toggle="modal" data-target="#updatepass-modal">
                            <i style={{ color: "white" }} className="fas fa-user" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="javascript:history.go(-1)">
                            <i style={{ color: "white" }} className="fas fa-backward" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" href="javascript:history.go(+1)">
                            <i style={{ color: "white" }} className="fas fa-forward" />
                        </a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" onClick={() => signOut()} href="#0">
                            <i style={{ color: "white" }} className="fa fa-sign-out" />
                        </a>
                    </li>
                </ul>
            </nav>



            <div className="modal fade" id="updatepass-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Update User Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" value={name} readOnly onChange={(e) => setName(e.target.value)} placeholder="Full name" required />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-user" />
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group mb-3">
                                    <input type="text" className="form-control" value={mobile} readOnly onChange={(e) => setMobile(e.target.value)} placeholder="Mobile No" required />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-phone" />
                                        </div>
                                    </div>
                                </div>
                                <div className="input-group mb-3">
                                    <input type="password" className="form-control" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="Password" />
                                    <div className="input-group-append">
                                        <div className="input-group-text">
                                            <span className="fas fa-lock" />
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="submit" onClick={() => handleUpdatePassword()} className="btn btn-primary" >Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Header